import { Box, Chip, Typography, Collapse } from '@mui/material';
import { Folder, FolderOpen } from '@mui/icons-material';
import { Description, Article, Note } from '@mui/icons-material';
import {
  // AccountTree,
  // Timeline,
  ViewList,
  // Dashboard,
} from '@mui/icons-material';

const TreeRow2 = ({
  node,
  level = 0,
  columns = [],
  onToggle,
  isExpanded,
  expandedIds,
  onProjectClick,
}) => {
  // console.log('testProp:', testProp); // Если undefined — точно импорт сломан

  const hasChildren = Boolean(node.children?.length);

  // console.log('TreeRow2 props:', {
  //   node: node.id,
  //   onProjectClick: typeof onProjectClick,
  //   hasChildren,
  // });

  const onClick = () => {
    if (hasChildren) {
      onToggle(node.id);
    } else if (node.isProject) {
      console.log('TreeRow2 onProjectClick:', node);
      // 🔥 Открываем модалку проекта
      // const projectId = node.id.replace(/^proj_/, ''); // Обрезаем!
      // Бэкенд теперь присылает готовый projectId.
      // || node.id... оставляем для старых отчетов, если они закешировались
      const targetId = node.projectId || node.id.replace(/^proj_/, '');
      onProjectClick(targetId, node.label);
    }
  };

  const getTreeIcon = () => {
    if (level === 0) return <ViewList />; // Корень
    if (node.isProject) return <Description />; // Проект
    if (!hasChildren) return '📄'; // Лист
    return isExpanded ? <FolderOpen /> : <Folder />; // Группа
  };

  const selectedStyle = expandedIds.has(node.id)
    ? { backgroundColor: 'action.selected' } // MUI тема!
    : {};

  return (
    <>
      {/* 🔥 ОСНОВНАЯ СТРОКА */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 0.75,
          px: 1.5,
          pl: `${level * 8 + 16}px`, // 🔥 2px * 4 = 8px на уровень + базовые 16px
          gap: 1,
          borderRadius: 0.5,
          // cursor: hasChildren ? 'pointer' : 'default',
          cursor: 'pointer',
          transition: 'all 0.2s',
          ...selectedStyle, // ✅ Твоя цветовая схема!
          '&:hover': { backgroundColor: 'action.hover' },
        }}
        onClick={onClick}
        // onClick={() => hasChildren && onToggle(node.id)}
      >
        {/* Иконка дерева */}
        <Typography variant='body1' sx={{ fontSize: '1.1rem', minWidth: 24 }}>
          {getTreeIcon()}
        </Typography>

        {/* Название */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant={node.isProject ? 'body1' : 'subtitle2'}
            color={node.isProject ? 'text.secondary' : 'text.primary'}
            noWrap
            title={node.label}
            sx={{
              whiteSpace: 'normal', // ← главное — разрешаем перенос
              wordBreak: 'break-word', // разбиваем очень длинные слова
              // или более мягкий вариант:
              // overflowWrap: 'break-word',
              hyphens: 'auto', // опционально: расставляет переносы (работает не везде)
              maxWidth: '100%', // на всякий случай
            }}
          >
            {node.label}
          </Typography>
        </Box>

        {/* Колонки */}
        {columns.map((col) => (
          <Typography key={col.field} variant='body1' noWrap sx={{ flex: 1 }}>
            {node[col.field] || '-'}
          </Typography>
        ))}

        {/* Метрики */}
        {!node.isProject && (
          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            <Typography variant='subtitle2' fontWeight={600}>
              {node.count}
            </Typography>
            {node.percentage > 0 && node.percentage < 100 && (
              <Chip
                label={`${node.percentage}%`}
                size='small'
                color='success'
                sx={{ fontSize: '0.65rem', height: 18, minWidth: 32 }}
              />
            )}
          </Box>
        )}
      </Box>

      {/* 🔥 ДЕТИ ПОД СТРОКОЙ (без отступов!) */}
      {hasChildren && (
        <Collapse in={isExpanded} timeout='auto' unmountOnExit>
          {node.children.map((child) => (
            <TreeRow2
              key={child.id}
              node={child}
              level={level + 1}
              columns={columns}
              onToggle={onToggle}
              isExpanded={expandedIds.has(child.id)}
              expandedIds={expandedIds}
              onProjectClick={onProjectClick}
            />
          ))}
        </Collapse>
      )}
    </>
  );
};

export default TreeRow2;
